import { Box, Button, Chip, Grid, Typography } from '@mui/material'
import React from 'react'

import { useAuth } from '../../../hooks/context/UserAuthContext'
import { format, parseISO } from 'date-fns'
import { Link as RouterLink } from 'react-router-dom'
import dealershipBrandsDict from '../../../constants/dealershipBrands'
import CustomerView from './CustomerView'

const UserView = ({ data, refetch }) => {
  return (
    <Grid container rowGap={1} sx={{ p: 2 }}>
      <Grid item xs={12}>
        <Box display='flex' justifyContent='flex-end'>
          <Button
            variant='outlined'
            LinkComponent={RouterLink}
            to={`/admin/users/edit/${data._id}`}
          >
            Edit
          </Button>
        </Box>
      </Grid>
      <CustomerView data={data} />
      {data.isAdmin && (
        <Grid item xs={12} sm={6} md={4}>
          <Chip color='primary' label='Admin' />
        </Grid>
      )}
      <Grid item xs={12} sm={6} md={4}>
        <Chip
          color={data.isActive ? 'success' : 'error'}
          label={data.isActive ? 'Active' : 'Inactive'}
        />
      </Grid>
      {data.createdAt && (
        <Grid item xs={12}>
          <Typography variant='subtitle1'>Created</Typography>
          <Typography variant='body2' color='textSecondary'>
            {format(parseISO(data.createdAt), 'dd/MM/yyyy')}
          </Typography>
        </Grid>
      )}
      {data.createdAt && (
        <Grid item xs={12}>
          <Typography variant='subtitle1'>Updated</Typography>
          <Typography variant='body2' color='textSecondary'>
            {format(parseISO(data.updatedAt), 'dd/MM/yyyy')}
          </Typography>
        </Grid>
      )}
    </Grid>
  )
}

export default UserView
